import { array, arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap/lib';
import Button from '../../Button/Button';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody/ModalBody';
import ReactSelect from '../../ReactSelect/ReactSelect';
import ReactSelectAsync from '../../ReactSelectAsync/ReactSelectAsync';

const JOB_FAMILIES_LABEL = 'Choose the Job Families associated with this competitive set';

export default class CompSetEditModal extends Component {
  static propTypes = {
    changeSetValue: func,
    closeEditSet: func,
    compSets: shape({
      currentEditSet: oneOfType([
        bool,
        shape({
          competitive_set_pk: number,
          competitive_set_name: string,
          creator_user_id: oneOfType([string, number]),
          creation_time: string,
          last_modifying_user_id: oneOfType([string, number]),
          last_modifying_user_name: string,
          company_type: string,
          employees_count: number,
          total_revenue: number,
          industry: array,
          government_contractor: bool,
          default_job_families: arrayOf(
            shape({
              label: string,
              value: string
            })
          ),
          job_family_list: arrayOf(
            shape({
              label: string,
              value: string
            })
          )
        })
      ]),
      items: arrayOf(
        shape({
          competitive_set_pk: number,
          competitive_set_name: string,
          creator_user_id: oneOfType([string, number]),
          creation_time: string,
          last_modifying_user_id: oneOfType([string, number]),
          last_modifying_user_name: string,
          company_type: string,
          employees_count: number,
          total_revenue: number,
          industry: array,
          government_contractor: bool,
          default_job_families: arrayOf(
            shape({
              label: string,
              value: string
            })
          ),
          job_family_list: arrayOf(
            shape({
              label: string,
              value: string
            })
          )
        })
      ),
      orgTypes: arrayOf(
        shape({
          label: string,
          value: string
        })
      ),
      saving: bool,
      showDeleteAlert: bool,
      validation: shape({
        isValid: bool,
        noChange: bool
      })
    }),
    getIndustryOptions: func,
    getOrgType: func,
    saveSet: func,
    isLab: bool
  };

  constructor(props) {
    super(props);

    this.change = this.change.bind(this);
    this.getFormattedValue = this.getFormattedValue.bind(this);
    this.handleCompanyTypeChange = this.handleCompanyTypeChange.bind(this);
    this.handleIndustryChange = this.handleIndustryChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.loadIndustryOptions = this.loadIndustryOptions.bind(this);
    this.saveSet = this.saveSet.bind(this);
  }

  componentDidMount() {
    const { getOrgType } = this.props;

    getOrgType();
  }

  componentDidUpdate(prevProps) {
    const { compSets } = this.props;

    if (prevProps.compSets.currentEditSet.default_job_families !== compSets.currentEditSet.default_job_families) {
      this.setState({ value: compSets.currentEditSet.default_job_families });
    }
  }

  change(event) {
    const { changeSetValue } = this.props;
    const name = event.target.id;
    const value = this.getFormattedValue(name, event);
    const type = event.target.type;
    const info = { type, name, value };

    changeSetValue(info);
  }

  getFormattedValue(name, event) {
    const targetEvent = event.target;

    switch (name) {
      case 'competitive_set_name':
        return targetEvent.value.slice(0, 34);
      case 'employees_count':
        return targetEvent.value !== '' ? parseInt(targetEvent.value, 10) : null;
      case 'government_contractor':
        return targetEvent.checked;
      case 'total_revenue':
        return targetEvent.value !== '' ? parseInt(targetEvent.value, 10) : null;
      default:
        return;
    }
  }

  handleCompanyTypeChange(selection) {
    const { changeSetValue } = this.props;
    const value = selection?.label;
    const info = { type: 'string', name: 'company_type', value };

    changeSetValue(info);
  }

  handleIndustryChange(selection) {
    const { changeSetValue } = this.props;
    const value = selection?.label;
    const info = { type: 'string', name: 'industry', value: [value] };

    changeSetValue(info);
  }

  handleSelectChange(value) {
    const { changeSetValue } = this.props;

    const info = { type: 'string', name: 'default_job_families', value };

    changeSetValue(info);
  }

  loadIndustryOptions(input, callback) {
    const { getIndustryOptions } = this.props;

    const params = {
      params: {
        numResults: null,
        industrySearchTerm: input
      },
      searchCallback: callback
    };

    input && input.length >= 2 ? getIndustryOptions(params) : callback([]);
  }

  saveSet() {
    const { compSets, saveSet } = this.props;
    const { currentEditSet, validation } = compSets;

    saveSet(currentEditSet, validation);
  }

  render() {
    const { closeEditSet, compSets, isLab } = this.props;
    const { currentEditSet, orgTypes, validation } = compSets;
    const filteredOrgTypes = orgTypes.filter(({ value }) => value === currentEditSet.company_type);
    const labelClass = 'label__form--addJob label__form--basicJobInfo';
    let showModal = currentEditSet ? true : false;

    return (
      <Modal className="container--pageroute add__set" onClose={closeEditSet} show={showModal}>
        <ModalBody className="compsets__page-modal">
          <h4 className="compsets__page-title">Add/Edit Competitive Set</h4>
          <div className="row">
            <div className="col-md-5">
              <Form>
                <FormGroup validationState={validation.competitive_set_name}>
                  <ControlLabel className={labelClass}>Competitive Set Name</ControlLabel>
                  <FormControl
                    id="competitive_set_name"
                    onChange={this.change}
                    type="string"
                    value={currentEditSet.competitive_set_name || undefined}
                  />
                </FormGroup>
                <FormGroup validationState={validation.employees_count}>
                  <ControlLabel className={labelClass}>Number of employees</ControlLabel>
                  <FormControl
                    id="employees_count"
                    onChange={this.change}
                    type="number"
                    value={currentEditSet.employees_count || undefined}
                  />
                </FormGroup>
                <FormGroup validationState={validation.company_type}>
                  <ControlLabel className={labelClass}>Organization type</ControlLabel>
                  <ReactSelect
                    getOptionLabel={option => option.label}
                    getOptionValue={option => option.value}
                    isClearable={true}
                    name="form-field-name"
                    onChange={this.handleCompanyTypeChange}
                    options={orgTypes}
                    value={filteredOrgTypes}
                  />
                </FormGroup>
              </Form>
            </div>
            <div className="col-md-2" />
            <div className="col-md-5">
              <Form>
                <FormGroup validationState={validation.total_revenue}>
                  <ControlLabel className={labelClass}>Total Revenue</ControlLabel>
                  <FormControl
                    id="total_revenue"
                    onChange={this.change}
                    type="number"
                    value={currentEditSet.total_revenue || undefined}
                  />
                </FormGroup>
                <FormGroup controlId="jobFormInfo" validationState={validation.industry}>
                  <ControlLabel className={labelClass}>Industry</ControlLabel>
                  <ReactSelectAsync
                    className={`react-select input__form--compsets ${validation.industry}`}
                    classNamePrefix="react-select"
                    loadOptions={this.loadIndustryOptions}
                    noOptionsMessage={() => 'Type to Search'}
                    onChange={this.handleIndustryChange}
                    value={{
                      label: currentEditSet.industry ? currentEditSet.industry[0] : null,
                      value: currentEditSet.industry ? currentEditSet.industry[0] : null
                    }}
                  />
                </FormGroup>
                <FormGroup validationState={validation.government_contractor}>
                  <div className="gov__contractor-checkbox">
                    <label>
                      <input
                        id="government_contractor"
                        checked={currentEditSet.government_contractor}
                        onChange={this.change}
                        type="checkbox"
                        value={!currentEditSet.government_contractor || undefined}
                      />
                      Government Contractor
                    </label>
                  </div>
                </FormGroup>
              </Form>
            </div>
          </div>
          <FormGroup className="compsets__family--box" validationState={validation.default_job_families}>
            <div className="compsets__jobfamily">
              <div>Job Family</div>
              <label className={labelClass}>{JOB_FAMILIES_LABEL}</label>
              <ReactSelect
                className={!isLab ? 'select__container-marketpay' : 'select__container-lab'}
                isClearable={true}
                isMulti
                noOptionsMessage={() => 'No results found'}
                onChange={this.handleSelectChange}
                options={currentEditSet.job_family_list}
                placeholder="Select..."
                value={currentEditSet.default_job_families}
              />
            </div>
          </FormGroup>
          <div className="button__container text-right">
            <Button className="pxl-btn cancel__btn-link" dataTestId="comp__set-cancel" onClick={closeEditSet}>
              Cancel
            </Button>
            <Button className="pxl-btn pxl-btn-primary save" dataTestId="comp__set-save" onClick={this.saveSet}>
              Save
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
